import { render, staticRenderFns } from "./FAB.vue?vue&type=template&id=962b5c88"
import script from "./FAB.vue?vue&type=script&lang=js"
export * from "./FAB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports